module.exports = __webpack_public_path__ + "static/media/normal.6a2fcb11.png";